import { connect } from "react-redux";
import React, { useMemo, useState } from "react";
import { CAlert, CButton, CCol, CForm, CInputGroup, CInputGroupText, CRow } from "@coreui/react";

import * as saleMethod from "../../../../api/method/saleMethod";
import StoreListWhere from "../../where/StoreListWhere";

import { DatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import { Loading } from "../../../../components/common";
import { AgGridReact } from "ag-grid-react";

import * as formatter from "../../../../config/formatter";
import * as commonUtil from "../../../../config/common";
import { getDailyHourlySale } from "../../../../api/method/saleMethod";

const { RangePicker } = DatePicker;
const DailyHourlySales = (props) => {
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);

  const [currentSaleStatData, setCurrentSaleStatData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    visible: false,
    message: ""
  });
  const [searchForm, setSearchForm] = useState({
    saleDt: dayjs()
  });

  const [columnDefs] = useState([
    {
      field: "formatSaleDt",
      headerName: "일자",
      width: 120,
      wrapHeaderText: true
    },
    {
      field: "formatSaleDt",
      headerName: "요일",
      width: 100,
      wrapHeaderText: true,
      valueFormatter: (e) => {
        const weekend = formatter.timeFormatter(e, "YYYY-MM-DD", "d");
        return commonUtil.getWeekendName(weekend);
      }
    },
    {
      field: "billCnt",
      headerName: "영수건수(일)",
      width: 100,
      wrapHeaderText: true,
      valueFormatter: formatter.currencyFormatter
    },
    { field: "saleAmt", headerName: "총매출액(일)", valueFormatter: formatter.currencyFormatter },
    { field: "netAmt", headerName: "가액(일)", valueFormatter: formatter.currencyFormatter },
    {
      headerName: "구간합계", children: [
        { field: "vaultAmt", headerName: "결제합계", valueFormatter: formatter.currencyFormatter },
        { field: "cashAmt", headerName: "현금영수", valueFormatter: formatter.currencyFormatter },
        { field: "cardAmt", headerName: "신용카드", valueFormatter: formatter.currencyFormatter }
      ]
    }
  ]);

  const search = () => {
    const { cmpCd, brandCd, storeCd } = props.selected;
    if (brandCd.length === 0) {
      setError({
        visible: true,
        message: "조회시 휴게소는 반드시 선택하셔야 합니다."
      });
      return;
    }

    if (storeCd.length === 0) {
      setError({
        visible: true,
        message: "조회시 매장은 반드시 선택하셔야 합니다."
      });
      return;
    }

    const params = {
      cmpCd: cmpCd,
      brandCd: brandCd,
      storeCd: storeCd,
      fromSaleDt: searchForm.fromSaleDt.format("YYYYMMDD"),
      toSaleDt: searchForm.toSaleDt.format("YYYYMMDD")
    };

    setLoading(true);
    saleMethod.getDailyHourlySale(params).then((result) => {
      console.log(result);
      setLoading(false);
      setCurrentSaleStatData(result);
    });
  };

  const onCellClicked = (params) => {
    console.log(params);
  };

  const handleSelect = (code, value) => {
    if (value === "C") {
      setSearchForm((state) => ({
        ...state,
        cmpCd: code
      }));
    } else if (value === "B") {
      setSearchForm((state) => ({
        ...state,
        brandCd: code
      }));
    } else if (value === "S") {
      setSearchForm((state) => ({
        ...state,
        storeCd: code
      }));
    } else if (value === "O") {
      setSearchForm((state) => ({
        ...state,
        cornerCd: code
      }));
    }
  };

  return (
    <>
      <div style={containerStyle}>
        {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
        <div className="d-grid gap-1 d-md-flex justify-content-between" style={{ marginBottom: 10 }}>
          <h5>시간대별 매출현황</h5>
          <CButton color="dark" onClick={search}>조회</CButton>
        </div>
        <CForm>
          <StoreListWhere account={props.account} selected={searchForm}
                          onSelect={(c, v) => handleSelect(c, v)}/>
          <CCol sm={5}>
            <CInputGroup>
              <CInputGroupText style={{ width: 100 }}>조회일자</CInputGroupText>
              <CInputGroupText style={{ background: "white", height: 38 }}>
                <RangePicker bordered={false}
                             separator={"~"}
                             placeholder={""}
                             locale={locale}
                             value={[searchForm.fromSaleDt, searchForm.toSaleDt]}
                             onChange={(dayjs, dateString) => {
                               setSearchForm((state) => ({
                                 ...state, fromSaleDt: dayjs[0], toSaleDt: dayjs[1]
                               }));
                             }}/>
              </CInputGroupText>
            </CInputGroup>
          </CCol>
          <CRow>
            <div className="ag-theme-alpine" style={{ width: "100%", height: 500, marginTop: 10 }}>
              {loading ? <Loading/> : null}
              <AgGridReact
                onCellClicked={onCellClicked}
                rowSelection={"single"}
                rowData={currentSaleStatData}
                animateRows={true}
                columnDefs={columnDefs}>
              </AgGridReact>
            </div>
          </CRow>
        </CForm>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const { account, store, selected } = state;
  return {
    account, store, selected
  };
};

export default connect(mapStateToProps, null)(DailyHourlySales);
